import { useQuery } from "@apollo/client";
import { createContext, ReactNode, useContext } from "react";
import { GET_USER_BROADCASTER_CONFIG } from "../queries/mutation/userBroadcasterConfig";
import { useAuth } from "./AuthProvider";

interface UserConfigPermissions {
  unlimitedHeadpats: boolean;
  isMod: boolean;
}

interface UserConfigContextType {
  permissions: UserConfigPermissions;
  loading: boolean;
  refetch: () => void;
}

const UserConfigContext = createContext<UserConfigContextType | undefined>(
  undefined,
);

export const UserConfigProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();

  const { data, loading, refetch } = useQuery(GET_USER_BROADCASTER_CONFIG, {
    variables: { userId: user?.id },
    skip: !user?.id,
    fetchPolicy: "network-only",
  });

  const permissions: UserConfigPermissions = {
    unlimitedHeadpats:
      data?.getUserBroadcasterConfig?.permissions?.unlimitedHeadpats || false,
    isMod: data?.getUserBroadcasterConfig?.permissions?.isMod || false,
  };
  console.log("UserConfigProvider permissions:", permissions);

  return (
    <UserConfigContext.Provider value={{ permissions, loading, refetch }}>
      {children}
    </UserConfigContext.Provider>
  );
};

export const useUserConfig = () => {
  const context = useContext(UserConfigContext);
  if (context === undefined) {
    throw new Error("useUserConfig must be used within UserConfigProvider");
  }
  return context;
};
